/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { APP_VERSION } from './version';

// Only production builds report. The dev stores and localhost build with the
// development configuration (environment.production false) and were filling
// the production quota with their own errors.
if (environment.production) {
  Sentry.init({
    dsn: "https://0390dcd815f361f8f70567b714def46b@o4508162247557120.ingest.us.sentry.io/4508174015463424",
    release: APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Stale-bundle chunk-load failures are self-healing: VersionCheckService
    // force-reloads the tab onto the fresh build (see version-check.service.ts).
    // They are not actionable and, right after a deploy, arrive in bursts large
    // enough to exhaust the Sentry quota (429s). Drop them at the source.
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to load module script',
      /Loading (CSS )?chunk/,
      'ChunkLoadError',
      'NG0750',
    ],
    // Tracing
    tracesSampleRate: 0, // off: transactions were burning the shared quota (DEV-11772)
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/admin\.phillyfoodworks\.com/,
      /^https:\/\/phillyfoodworks\.com/
    ],
    // Session Replay
    replaysSessionSampleRate: 0, // record only the sessions that hit an error
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
